module.exports = __webpack_public_path__ + "img/rear.b4c4a913.svg";